import { Carousel } from 'antd'
import React from 'react'
import ADAddition from '../../assets/ad-big-2.jpeg'
import ADBig from '../../assets/ad-big.jpeg'
import ADSmall from '../../assets/ad-small.jpeg'
import ADSuper from '../../assets/ad-super.jpeg'

const ADList = [
  {
    link: 'https://www.shenmacredit.com.my/motorcycle-financing-solutions',
    img: ADAddition,
  },
  {
    link: 'https://www.shenmacredit.com.my/big-bike-financing',
    img: ADBig,
  },
  {
    link: 'https://www.shenmacredit.com.my/small-bike-financing',
    img: ADSmall,
  },
  {
    link: 'https://www.shenmacredit.com.my/super-bike-financing',
    img: ADSuper,
  },
]

export const Ad: React.FC = () => {
  return (
    <Carousel>
      {ADList.map((ad) => (
        <div key={ad.link}>
          <a href={ad.link} target="_blank" rel="noreferrer">
            <img src={ad.img} alt="ad" />
          </a>
        </div>
      ))}
    </Carousel>
  )
}
